import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Button } from 'semantic-ui-react';
import axios from '../../../util/CustomAxios';
import { getFormValues, getFormSyncErrors } from 'redux-form';
import { Link, Redirect } from 'react-router-dom';

import { BallLoader } from '../../General/BallLoader';
import {
  resolveRate,
  computeLineAmount,
} from '../../SalesOrder/presenters/setRate';
import { roundCurrency } from '../../../util/currency';
import '../../SalesOrder/SalesOrder.css';

class ButtonContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmited: false,
      createdSOID: -1,
      isLoading: false,
    };
    this.submitButtonOnClickHandler =
      this.submitButtonOnClickHandler.bind(this);
  }
  submitButtonOnClickHandler(event, data) {
    for (let error in this.props.SalesOrderFormDataError) {
      console.log(error);
      if (this.props.SalesOrderFormDataError[error] != '') {
        //console.log(this.SalesOrderFormDataError[error])
        return;
      }
    }

    const SalesOrderData = {
      ...this.props.SalesOrderFormData,
      AccountID: this.props.SalesOrderFormData.billingAccountID,
      Status: 4,
      Payment: null, // always null
      DateofShipment: null, // always null
      DateofPickUp: null, // always null
      Currency: this.props.currency.trim(),
      Amount: roundCurrency(
        Number(this.props.subTotal) +
          Number(this.props.SalesOrderFormData.ShippingCharge) +
          Number(this.props.SalesOrderFormData.Adjustment),
        this.props.currency
      ),
      Company: this.props.company,
      SODetailes: this.props.SODetailes,
    };

    const invoiceData = {
      inv_num: null,
      so_id: this.props.SOID,
      packing_info: '',
      created_date: this.props.SalesOrderFormData.SOIssueDate,
      isDeleted: null,
      airtable_id: null,
      order_type: this.props.SalesOrderFormData.SOType,
      terms_of_delivery: this.props.SalesOrderFormData.TermsOfDelivery,
      delivery_method: this.props.SalesOrderFormData.DeliveryMethod,
      ship_to: this.props.SalesOrderFormData.ship_to,
      bill_to: this.props.SalesOrderFormData.bill_to,
      shipping_account: this.props.SalesOrderFormData.shippingAccountID,
      billing_account: this.props.SalesOrderFormData.billingAccountID,
      shipping_contact: null,
      billing_contact: null,
      note: '',
      amount: roundCurrency(
        Number(this.props.subTotal) +
          Number(this.props.SalesOrderFormData.ShippingCharge) +
          Number(this.props.SalesOrderFormData.Adjustment),
        this.props.currency
      ),
      adjustment: Number(this.props.SalesOrderFormData.Adjustment),
      shipment_id: null,
      pick_up_date: null,
      shipping_date: null,
      arrival_date: null,
      shipping_charge:
        Number(this.props.SalesOrderFormData.ShippingCharge) || 0,
      company: this.props.company,
      currency: this.props.currency,
    };

    const productData = [...this.props.SODetailes];

    this.setState({
      isLoading: true,
    });
    if (this.props.isEdit) {
      axios
        .put(`/Invoice/${this.props.SOID}`, SalesOrderData)
        .then((response) => {
          this.setState({
            isSubmited: true,
            createdInvoiceId: this.props.createdInvoiceId,
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
          alert('에러가 발생했습니다. 담당자에게 문의해주세요.');
        });
    } else {
      axios
        .post(`/Invoice/${this.props.SOID}`, {
          invoice: invoiceData,
          product: productData,
        })
        .then((response) => {
          this.setState({
            isSubmited: true,
            createdInvoiceId: response.data.createdInvoiceId,
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({
            isLoading: false,
          });
          alert('에러가 발생했습니다. 담당자에게 문의해주세요.');
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <BallLoader /> : null}
        {this.state.isSubmited ? (
          <Redirect to={`/Invoice/${this.state.createdInvoiceId}`} />
        ) : null}
        <Grid.Row stretched style={this.props.style}>
          <Grid.Column width={10} verticalAlign="middle"></Grid.Column>
          <Grid.Column width={3} verticalAlign="middle">
            <Link
              to={
                this.props.isEdit
                  ? `/SalesOrder/${this.props.SOID}`
                  : '/SalesOrder'
              }
            >
              <Button size="big" className="CancelButton">
                Cancel
              </Button>
            </Link>
          </Grid.Column>
          <Grid.Column width={3} verticalAlign="middle">
            <button
              class="big ui button"
              type="submit"
              onClick={this.submitButtonOnClickHandler}
            >
              {this.props.isEdit ? 'Save' : 'Submit'}
            </button>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  }
}

export default connect((state) => ({
  currency: !!state.selectedCustomer.billingCustomer.Currency
    ? state.selectedCustomer.billingCustomer.Currency.trim()
    : 'USD',
  selectedCustomer: state.selectedCustomer.billingCustomer,
  // 각 라인 금액의 합을 통화 기준으로 반올림한다(부동소수점 합산 오차 제거).
  // 저장되는 subTotal이 Invoice 화면의 Amount Total과 동일한 값이 되도록 한다.
  subTotal: roundCurrency(
    state.productOrderList.reduce((a, b) => {
      return (
        a +
        computeLineAmount(
          b,
          state.selectedCustomer.billingCustomer.Currency,
          state.company,
          state.billingCountry
        )
      );
    }, 0),
    state.selectedCustomer.billingCustomer.Currency
  ),
  SalesOrderFormData: !!getFormValues('SalesOrder')(state)
    ? getFormValues('SalesOrder')(state)
    : null,
  SalesOrderFormDataError: getFormSyncErrors('SalesOrder')(state),

  SODetailes: state.productOrderList.map((productOrder) => {
    return {
      ProductID:
        productOrder.product.ProductID || productOrder.product.ProductId,
      Currency:
        state.selectedCustomer.billingCustomer.Currency == undefined
          ? 'USD'
          : state.selectedCustomer.billingCustomer.Currency.trim(),
      Rate: resolveRate(
        productOrder,
        state.selectedCustomer.billingCustomer.Currency == undefined
          ? 'USD'
          : state.selectedCustomer.billingCustomer.Currency.trim(),
        state.company,
        state.billingCountry
      ),
      Quantity: productOrder.quantity,
      Discount: productOrder.discount,
      Amount: computeLineAmount(
        productOrder,
        state.selectedCustomer.billingCustomer.Currency,
        state.company,
        state.billingCountry
      ),
      IsCustomDiscount: productOrder.isCustomDiscount,
      Serial: null,
      SOIID: productOrder.SOIID,
    };
  }),
  shippingCustomerID: state.shippingCustomerID,
  company: state.company,
  billingCountry: state.billingCountry,
}))(ButtonContainer);
